import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Package {
  private readonly http = inject(HttpClient);

  getPackages(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.package.packageList}`, {
      params: filters
    });
  }

  addPackage(pkg: any): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.package.addPackage}`, pkg);
  }

  uploadPackages(formData: FormData): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.package.packages}`, formData);
  }

  editPackage(pkgId: string, pkg: any): Observable<any> {
    return this.http.put<any>(
      `${environment.apiPrefix}${environment.package.packages}/${pkgId}`,
      pkg
    );
  }

  deletePackage(pkgId: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiPrefix}${environment.package.packages}/${pkgId}`
    );
  }
}
